import { render, staticRenderFns } from "./NotifiersEditor.vue?vue&type=template&id=d40479ea&"
import script from "./NotifiersEditor.vue?vue&type=script&lang=js&"
export * from "./NotifiersEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports